// src/components/AssignOptions.js
import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';

function AssignOptions() {
  const navigate = useNavigate();
  const { loadId } = useParams();

  return (
    <div>
      <h1>Assign Options</h1>
      <button onClick={() => navigate(`/loads/assign-truck/${loadId}`)}>Assign Truck</button>
      <button onClick={() => navigate(`/loads/assign-trailer/${loadId}`)}>Assign Trailer</button>
      <button onClick={() => navigate(`/loads/assign-driver/${loadId}`)}>Assign Driver</button>
    </div>
  );
}

export default AssignOptions;
